import { moduleFactory } from "@/factories/module";
import {
  releaseAudioRecorderLock,
  takeAudioRecorderLock,
} from "@/modules/audio-recording/audio-recorder-lock";
import {
  convertAudioRecordingFloat32ToPcm16,
  decodeAudioRecordingBlobToAudioBuffer,
  encodeAudioRecordingPcm16ToBase64,
  resampleAudioRecordingBufferToMono,
} from "@/modules/audio-recording/audio-processing";
import {
  mapAssemblyAiTurnPayloadToRecorderTurn,
  normalizeAudioRecordingTimestamp,
  collapseRecorderTranscriptTurns,
  resolveAssemblyAiRealtimePayloadType,
} from "@/modules/audio-recording/audio-transcription";
import { assemblyAiTokenProvider } from "@/modules/audio-recording/assembly-ai";
import {
  buildRecorderChunkFromPcm,
  normalizeDesktopTranscriptTurn,
  transformBlobToPlayableFormat,
} from "@/modules/audio-recording/desktop-utils";

export const audioRecordingModule = moduleFactory.create({
  takeLock: takeAudioRecorderLock,
  releaseLock: releaseAudioRecorderLock,
  decodeBlobToAudioBuffer: decodeAudioRecordingBlobToAudioBuffer,
  resampleToMono: resampleAudioRecordingBufferToMono,
  convertFloat32ToPcm16: convertAudioRecordingFloat32ToPcm16,
  encodePcm16ToBase64: encodeAudioRecordingPcm16ToBase64,
  mapAssemblyAiTurnPayloadToRecorderTurn,
  normalizeAssemblyAiTimestamp: normalizeAudioRecordingTimestamp,
  collapseRecorderTranscriptTurns: collapseRecorderTranscriptTurns,
  assemblyAiTokenProvider: assemblyAiTokenProvider,
  resolveAssemblyAiRealtimePayloadType,
  buildRecorderChunkFromPcm,
  normalizeDesktopTranscriptTurn,
  transformBlobToPlayableFormat,
});
